<div class="c">
  <div class="headerback">
    <!-- <button mat-icon-button aria-label="Example icon button with a vertical three dot icon" class="backbtn">
           <mat-icon>arrow_back</mat-icon>
         </button> -->

    <button mat-mini-fab color="white" style="color:#fff" aria-label="profile icon" (click)="backhome()"
      class="backbtn">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <p class="title">{{publicservice.Texts.Texts["wallet1"]}}</p>

  </div>

  <mat-tab-group mat-align-tabs="center" class="tabs" color="primary" backgroundColor="primary"
    [selectedIndex]="active">

    <mat-tab label="کمک به خیریه">
      <div class="charity"
        style="background-color: rgb(253, 214, 214);padding: 5% 3%;border-radius: 10px;text-align:center">
        <div class="attention" style="padding-right: 5px;padding-left: 5px;text-align: right;font-size: large;">
          <p style="padding-top: 7px;padding-right: 10px;">شما می توانید با بخشیدن کل یا مبلغی از اعتبارتان به خیریه کمک
            کنید</p>
          <img src="assets/images/love.png" style="width: 50px;height: 50px;">
        </div>
        <div class="inputshaba" style="justify-content: center; margin-bottom: -10px;">
          <p class="ir-charity">تومان</p>
          <mat-form-field appearance="fill" style="width: 250px;">

            <!-- <mat-label>شماره شبا</mat-label> -->
            <input matInput [formControl]="mablaghCharity" [(ngModel)]="publicservice.moneyCharity" pattern="[0-9]*">
            <mat-error *ngIf="mablaghCharity.hasError('required')" class="error">
              لطفا مبلغ را وارد کنید
            </mat-error>
          </mat-form-field>
        </div>
        <p [class]="key2"
          style="font-family: iransans;color: #ff5656;width: 100%;text-align: center;margin-bottom: 20px;">مبلغ وارد شده
          از مقدار اعتبار شما بیشتر است</p>


        <div class="back-btn">
          <button mat-button type="button" class="back-charity" (click)="charityClick()">
            کمک به خیریه</button>
        </div>
      </div>
    </mat-tab>


    <mat-tab label="دریافت اعتبار">
      <div class="wrapper">

        <div class="credit">
          <p style="padding-right: 3px;direction: rtl;"> {{credit}} تومان</p>
          <p>{{publicservice.Texts.Texts['wallet4']}}</p>
        </div>

        <p class="enteghal" style="padding-top: 40px;justify-content: center;">{{publicservice.Texts.Texts["wallet2"]}}
        </p>
        <p class="enteghal2" style="padding-top: 5px;justify-content: center;">{{publicservice.Texts.Texts["wallet7"]}}
        </p>

        <div class="inputshaba" style="justify-content: center;margin-bottom: 10px;">
          <!-- <p class="ir">IR</p> -->
          <mat-form-field appearance="outline" style="width: 250px;">

            <!-- <mat-label>شماره شبا</mat-label> -->
            <input matInput [formControl]="shaba" [(ngModel)]="publicservice.shaba" pattern="[0-9]*">
            <mat-error *ngIf="shaba.hasError('pattern') && !shaba.hasError('required')" class="error">
              <p class="text-break">شماره اشتباه است</p>
            </mat-error>
            <!-- <mat-hint>Hint</mat-hint> -->
            <mat-error *ngIf="shaba.hasError('required')" class="error">
              شماره را وارد کنید
            </mat-error>
          </mat-form-field>
        </div>

        <p class="enteghal">{{publicservice.Texts.Texts["wallet3"]}}</p>
        <div class="inputshaba" style="justify-content: center; margin-bottom: -10px;">
          <p class="ir">تومان</p>
          <mat-form-field appearance="outline" style="width: 250px;">

            <!-- <mat-label>شماره شبا</mat-label> -->
            <input matInput [formControl]="mablagh" [(ngModel)]="publicservice.moneyKifePul" pattern="[0-9]*">
            <!-- <mat-error *ngIf="mablagh.hasError('pattern') && !mablagh.hasError('required')"
            class="error">
            <p class="text-break">مبلغ صحیح را وارد کنید</p>
        </mat-error> -->
            <mat-error *ngIf="mablagh.hasError('required')" class="error">
              مبلغ را وارد کنید
            </mat-error>
          </mat-form-field>

        </div>
        <div style="padding-top: 10px;">
          <p [class]="key"
            style="font-family: iransans;color: #ff5656;width: 100%;text-align: center;margin-bottom: 20px;">مبلغ وارد
            شده از مقدار اعتبار شما بیشتر است</p>
          <p [class]="key3"
            style="font-family: iransans;color: #ff5656;width: 100%;text-align: center;margin-bottom: 20px;">مبلغ وارد
            شده از 10 هزار تومن کمتر است</p>
        </div>

        <div class="attention" style="margin-top: 10px;padding-right: 5px;padding-left: 5px;">
          <p style="padding-top: 2px;">{{publicservice.Texts.Texts["wallet5"]}}</p>
          <mat-icon style="padding-left: 5px;">report</mat-icon>
        </div>

        <div class="back-btn" (click)="okClick()">
          <button mat-button type="button" class="back">
            {{publicservice.Texts.Texts['wallet6']}}</button>
        </div>

      </div>
    </mat-tab>


  </mat-tab-group>
</div>